import styled from "styled-components";

export const PrizeValueDefaultBox = styled.div`
    
    @media ${({theme}) => `${theme.mediaQuery.lAndAbove} and ${theme.mediaQuery.landscape}`} {
        font-size: 3.2rem;
    }
    font-size: 2rem;
    font-weight: 900;
    background: linear-gradient(180deg, #FCE403 0%, #7FF800 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media ${({theme}) => theme.mediaQuery.portrait} {
        text-align: center;
    }
`;